<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chaptertitle1"><b>Contents</b></h2>
<p class="toc"><a href="#/foreword">Foreword</a></p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/intro">Introduction</a></p>
<p class="toc"><a href="#/chap1">Egg and Cheese Dishes</a></p>
<p class="toc"><span href="#/chap2" title="Link target outside of Sample">Biscuits and Breads</span></p>
<p class="toc"><span href="#/chap3" title="Link target outside of Sample">Sides</span></p>
<p class="toc"><span href="#/chap4" title="Link target outside of Sample">Soups and Stews</span></p>
<p class="toc"><span href="#/chap5" title="Link target outside of Sample">Main Courses</span></p>
<p class="toc"><span href="#/chap6" title="Link target outside of Sample">Desserts</span></p>
<p class="toc"><span href="#/chap7" title="Link target outside of Sample">Beverages</span></p>
<p class="toc"><span href="#/chap8" title="Link target outside of Sample">Accompaniments</span></p>
<p class="toc"><span href="#/ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/resources" title="Link target outside of Sample">Selected Resources</span></p>
<p class="toc"><span href="#/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?249aa716